import React from "react"
import { useAppContext } from "../../context/appContext";
import { Calendar, dayjsLocalizer } from "react-big-calendar";
import dayjs from "dayjs";

const EVENT_COLORS = {
  1: "#7986cb",
  2: "#33b679",
  3: "#8e24aa",
  4: "#e67c73",
  5: "#f6bf26",
  6: "#f4511e",
  7: "#039be5",
  8: "#616161",
  9: "#3f51b5",
  10: "#0b8043",
  11: "#d50000",
};

function JobsCalendar({ chosenAppt, setChosenAppt }) {
  const localizer = dayjsLocalizer(dayjs);
  const { calendarAppts } = useAppContext();

  const handleSelectAppt = (appt) => {
    setChosenAppt(appt);
  };

  const eventPropGetter = (event) => {
    const colorId = event.colorId || "9"
    const bgColor = EVENT_COLORS[colorId];
    const isLight = ["4", "5", "6"].includes(colorId);

    if (event === chosenAppt) {
      return { style: { backgroundColor: "#4d93ff", border: `1px solid black` } };
    } else {
      return {
        style: {
          backgroundColor: bgColor,
          color: isLight ? "#1d1d1d" : "#ffffff",
          border: `1px solid ${bgColor}`,
        },
      };
    }
  };

  return (
    <div className="group one-half">
      <form className="form">
        <Calendar
          localizer={localizer}
          defaultView="week"
          events={calendarAppts || []}
          startAccessor="start"
          endAccessor="end"
          eventPropGetter={eventPropGetter}
          onSelectEvent={handleSelectAppt}
          min={new Date(2024, 12, 14, 7, 0, 0)} // Set min time to 7 AM
          max={new Date(2024, 12, 14, 20, 0, 0)} // Set max time to 8 PM
          style={{ height: 500 }}
          selected={chosenAppt}
        />
      </form>
    </div>
  );
}
export default JobsCalendar;
